window._ = require('lodash');

window.$ = require('jquery');
window.$.fn.scrollTo = function(elem, speed) {
    $(this).animate({
        scrollTop:  $(this).scrollTop() - $(this).offset().top + $(elem).offset().top
    }, speed == null ? 1000 : speed);
    return this;
};

window.axios = require('axios');
window.axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest'
};

try {
    require('bootstrap');
} catch (e) {}

